/**
 * Product Price Utilities
 * 
 * Simple utility functions for price formatting.
 * Pricing is now determined by pre-defined Shopify variants.
 */

class ProductPriceCalculator {
  /**
   * Format price for display
   * @param {number} price - Price in dollars
   * @returns {string} - Formatted price string
   */
  static formatPrice(price) {
    return `$${price.toFixed(2)}`;
  }

  /**
   * Get human-readable rental period
   * @param {number} days - Number of days
   * @returns {string} - Human readable period (e.g., "10 days", "2 weeks")
   */
  static formatRentalPeriod(days) {
    if (days === 1) return '1 day';
    if (days === 7) return '1 week';
    if (days === 14) return '2 weeks';
    if (days % 7 === 0) {
      const weeks = days / 7;
      return `${weeks} weeks`;
    }
    return `${days} days`;
  }
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductPriceCalculator;
}

// Make available globally
window.ProductPriceCalculator = ProductPriceCalculator;
